module.exports = __webpack_public_path__ + "static/media/column.be773fce.svg";